import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import colors from 'vuetify/lib/util/colors';

Vue.use(Vuetify);
export default new Vuetify({
  theme: {
    light: false,
    themes: {
      light: {
        primary: '#6f42c1',
        secondary: colors.grey.darken1,
        accent: colors.shades.black,
        error: colors.red.accent3,
        themebtn:'#fd9200',
        white:'#fff'
      },
      dark: {
        primary: '#6cbcf4',
        secondary: '#ff0000',
      },
    },
  },
  icons: {iconfont: 'md',},
});
